module.exports = __webpack_public_path__ + "img/expired.6e03e3ea.svg";